<template>
  <b-card>
    <loading-container v-if="provider.loading" />
    <error-display v-else-if="provider.error" />
    <div v-else>
      <h1 class="d-flex align-items-center mb-2">
        <b-img
          v-if="provider.data.providerId && !isExcluded"
          :src="`${baseURL}serveproviderlogo.cfm?id=${provider.data.providerId}`"
          alt="provider logo"
          class="provider-logo mr-2"
        />
        {{ provider.data.providerName }}
      </h1>
      <b-row v-if="!isExcluded">
        <b-col
          v-if="provider.data.companyName"
          cols="3"
          class="mb-2"
        >
          <h4 class="mb-0 text-muted">
            Full Company Name
          </h4>
          <h3 class="mb-0">
            {{ provider.data.companyName }}
          </h3>
        </b-col>
        <b-col
          v-if="hasAddress"
          cols="3"
          class="mb-2"
        >
          <h4 class="mb-0 text-muted">
            Address
          </h4>
          <h6 class="mb-0">
            <span v-if="provider.data.address1">{{ provider.data.address1 }}</span>
            <span v-if="provider.data.address2"><br>{{ provider.data.address2 }}</span>
            <span v-if="provider.data.address3"><br>{{ provider.data.address3 }}</span>
          </h6>
        </b-col>
        <b-col cols="3">
          <b-row>
            <b-col
              v-if="provider.data.telephone"
              cols="12"
              class="mb-2"
            >
              <h4 class="mb-0 text-muted">
                Telephone
              </h4>
              <h6 class="mb-0">
                {{ provider.data.telephone }}
              </h6>
            </b-col>
            <b-col
              v-if="provider.data.email"
              cols="12"
              class="mb-2"
            >
              <h4 class="mb-0 text-muted">
                Email
              </h4>
              <h6 class="mb-0">
                {{ provider.data.email }}
              </h6>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="3">
          <b-row>
            <b-col
              v-if="provider.data.platform"
              cols="12"
              class="mb-2"
            >
              <h4 class="mb-0 text-muted">
                Platform
              </h4>
              <h6 class="mb-0">
                <a
                  :href="provider.data.platform"
                  target="_blank"
                >
                  {{ provider.data.providerName }} platform
                  <feather-icon
                    icon="ExternalLinkIcon"
                    size="14"
                    class="ml-25"
                    style="margin-bottom: 2px;"
                  />
                </a>
              </h6>
            </b-col>
            <b-col
              v-if="provider.data.website"
              cols="12"
              class="mb-2"
            >
              <h4 class="mb-0 text-muted">
                Website
              </h4>
              <h6 class="mb-0">
                <a
                  :href="provider.data.website"
                  target="_blank"
                >
                  {{ provider.data.providerName }} website
                  <feather-icon
                    icon="ExternalLinkIcon"
                    size="14"
                    class="ml-25"
                    style="margin-bottom: 2px;"
                  />
                </a>
              </h6>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="!hasContactInfo"
          cols="12"
        >
          <h4 class="mb-0 text-muted">
            Contact Details
          </h4>
          <h6 class="mb-0">
            None
          </h6>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BRow, BCol,
} from 'bootstrap-vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'

export default {
  components: {
    BCard,
    BImg,
    BRow,
    BCol,
    LoadingContainer,
    ErrorDisplay,
  },
  props: {
    provider: {
      type: Object,
      required: true,
    },
    isExcluded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BACKEND_PATH,
    }
  },
  computed: {
    hasContactInfo() {
      return this.provider.data && (
        this.provider.data.companyName
        || this.provider.data.address1
        || this.provider.data.address2
        || this.provider.data.address3
        || this.provider.data.telephone
        || this.provider.data.platform
        || this.provider.data.website
        || this.provider.data.email
      )
    },
    hasAddress() {
      return this.provider.data && (
        this.provider.data.address1
        || this.provider.data.address2
        || this.provider.data.address3
      )
    },
  },
}
</script>

<style scoped>
.provider-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
</style>
